import React, { useState, useEffect } from "react";
import Axios from "axios";
import { API_BASE_URL } from "../../Config";
import PropTypes from "prop-types";
import SpinLoader from "../loader/SpinLoader";
import Swal from "sweetalert2";

const EditAdvanceBooking = ({ booking, onClose }) => {
  const quotationId = booking?.Id;
  const [userDataSession, setUserDataSession] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [expectedDelivery, setExpectedDelivery] = useState("");
  const [notes, setNotes] = useState("");

  // 1. Get user session
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    }
  }, []);

  // 2. Fetch quotation details
  useEffect(() => {
    if (!quotationId || !userDataSession?.OrgId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const url = `${API_BASE_URL}Billing/getQuotationsById?QuotaionId=${quotationId}`;
        const res = await Axios.get(url);

        if (res.data?.Status && res.data?.ResultData?.length) {
          const item = res?.data?.ResultData[0];
          setData(item);
          setExpectedDelivery(item.ExpectedDelivery?.split("T")[0] || "");
          setNotes(item.Notes || "");
        } else {
          setData(null);
        }
      } catch (err) {
        console.error("Error fetching quotation:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [quotationId, userDataSession]);

  // 3. Save changes
  const handleSave = async () => {
    if (!data || !userDataSession) return;

    const payload = {
      Id: data?.Id,
      OrgId: userDataSession?.OrgId,
      ExpectedDelivery: expectedDelivery || null,
      Notes: notes.trim() || null,
      UpdatedBy: userDataSession?.UserId,
    };

    setSaving(true);
    try {
      const res = await Axios.post(
        `${API_BASE_URL}Billing/editQuotation`,
        payload
      );

      if (res.data?.Status && res.data?.ResultData?.[0]?.Success === 1) {
        const message =
          res.data.ResultData[0].Message || "Updated successfully.";
        Swal.fire("Success", message, "success").then(() => {
        window.location.reload();
        });
        onClose?.();
      } else {
        Swal.fire(
          "Error",
          res.data?.ResultData?.[0]?.Message || "Update failed",
          "error"
        );
      }
    } catch (err) {
      Swal.fire("Error", "Failed to save changes", "error");
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {loading && <SpinLoader />}
      <div className="modal fade " tabIndex="-1" id="editAdvanceBooking">
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: "500px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Edit Advance Booking ({data?.QuotaionNo})
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSave();
                }}
              >
                <div className="mb-3">
                  <label className="form-label small text-muted">
                    Expected Delivery
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={expectedDelivery}
                    onChange={(e) => setExpectedDelivery(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label small text-muted">Notes</label>
                  <textarea
                    className="form-control form-control-sm"
                    rows={4}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Enter notes..."
                  />
                </div>

                <div className="d-flex gap-2 justify-content-end mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    data-bs-dismiss="modal"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={saving}
                
                  >
                    {saving ? "Saving..." : "Save Changes"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

EditAdvanceBooking.propTypes = {
  booking: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditAdvanceBooking;
